export const initInview = () => {
    const fadeInParents = document.querySelectorAll<HTMLElement>('.js-fadeIn');
    const fadeInChildren = document.querySelectorAll<HTMLElement>('.js-fadeIn2');

    // どちらの要素も存在しない場合は、無駄な計算をせず終了
    if (fadeInParents.length === 0 && fadeInChildren.length === 0) return;

    // ================================
    // 親：ちょっと見えたら発火（1%） -- .js-fadeIn
    // ================================
    const parentObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
        entry.target.classList.add('is-active');
        parentObserver.unobserve(entry.target);
        }
    });
    }, {
        threshold: 0,
        rootMargin: '0px 0px -100px 0px'
    });

    fadeInParents.forEach(el => parentObserver.observe(el));


    // ================================
    // 子：半分見えたら発火（50%） -- .js-fadeIn2
    // ================================
    const childObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
        entry.target.classList.add('is-active2');
        childObserver.unobserve(entry.target);
        }
    });
    }, {
        threshold: 0.5 // ★半分以上見えたら発火
    });

    fadeInChildren.forEach(el => childObserver.observe(el));
};